window.ITConnect = window.ITConnect || {};

window.ITConnect.helpers = {
    csrfToken() {
        return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    },

    refreshIcons() {
        if (window.lucide) {
            window.lucide.createIcons();
        }
    },

    notify(type, message) {
        if (window.toastr) {
            window.toastr[type || 'info'](message);
        }
    },

    showLoader() {
        document.body.classList.add('is-loading');
        document.getElementById('pageLoader')?.setAttribute('aria-hidden', 'false');
    },

    hideLoader() {
        document.body.classList.remove('is-loading');
        document.getElementById('pageLoader')?.setAttribute('aria-hidden', 'true');
    },

    serializeForm($form) {
        const data = {};

        $form.serializeArray().forEach((field) => {
            data[field.name] = field.value;
        });

        return data;
    },
};
